import { render, staticRenderFns } from "./HistorialCar.vue?vue&type=template&id=59a860e0&scoped=true&"
import script from "./HistorialCar.vue?vue&type=script&lang=js&"
export * from "./HistorialCar.vue?vue&type=script&lang=js&"
import style0 from "./HistorialCar.vue?vue&type=style&index=0&id=59a860e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a860e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
